import { CheckCircle } from "lucide-react";
import ContactForm from "./ContactForm";

const HeroSection = () => {
  return (
    <section id="hero" className="relative pt-28 pb-16 md:pt-32 md:pb-24 bg-gradient-warm overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* Left content */}
          <div className="animate-fade-in">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary/20 text-secondary-foreground text-xs font-semibold tracking-wide uppercase mb-6">
              Profesjonalne strony internetowe
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground leading-tight mb-6">
              Twoja strona www <br />
              <span className="text-gradient-gold">nie musi kosztować fortuny</span>
            </h1>
            <p className="text-lg text-muted-foreground max-w-lg mb-6 font-body">
              Tworzymy indywidualne, nowoczesne strony internetowe w konkurencyjnych cenach.
              Od małych firm po duże przedsiębiorstwa — każdy projekt jest szyty na miarę
              Twoich potrzeb.
            </p>
            <div className="flex flex-wrap gap-6 text-sm text-muted-foreground mb-8">
              <div className="flex items-center gap-2">
                <CheckCircle className="text-secondary" size={18} />
                <span>Indywidualny projekt</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="text-secondary" size={18} />
                <span>Responsywność</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle className="text-secondary" size={18} />
                <span>Pozycjonowanie SEO</span>
              </div>
            </div>

            {/* Dodatkowe info */}
            <div className="grid grid-cols-3 gap-4 mb-6">
              <div className="bg-card/60 rounded-xl p-4 border border-border text-center">
                <p className="text-2xl font-display font-bold text-primary">100+</p>
                <p className="text-xs text-muted-foreground mt-1">Zrealizowanych projektów</p>
              </div>
              <div className="bg-card/60 rounded-xl p-4 border border-border text-center">
                <p className="text-2xl font-display font-bold text-primary">24h</p>
                <p className="text-xs text-muted-foreground mt-1">Czas odpowiedzi</p>
              </div>
              <div className="bg-card/60 rounded-xl p-4 border border-border text-center">
                <p className="text-2xl font-display font-bold text-primary">5★</p>
                <p className="text-xs text-muted-foreground mt-1">Ocena klientów</p>
              </div>
            </div>

            <p className="text-sm text-muted-foreground font-body leading-relaxed">
              Specjalizujemy się w tworzeniu stron dla małych, średnich i dużych firm — od wizytówek po rozbudowane sklepy internetowe. 
              Każdy projekt obejmuje optymalizację SEO, szybkość ładowania i pełną responsywność na wszystkich urządzeniach.
            </p>
          </div>

          {/* Right - Contact form */}
          <div className="animate-fade-in w-full lg:max-w-lg xl:max-w-xl lg:ml-auto" style={{ animationDelay: "0.2s" }} id="kontakt">
            <div className="bg-card rounded-2xl shadow-warm-lg p-6 border border-border">
              <h2 className="text-xl font-display font-bold text-foreground mb-1">
                Darmowa wycena
              </h2>
              <p className="text-xs text-muted-foreground mb-4">
                Opisz swój projekt — odezwiemy się w ciągu 24h
              </p>
              <ContactForm compact />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
